import { DefaultService } from '@/services/DefaultService';

export default class TabPrecoService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    loadName(id) {
		return this._http.get(`${this._env}/vendas/tabpreco/name.json?id=${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    save(tipo) {
        return this._http.post(`${this._env}/vendas/tabpreco`, tipo, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    find(id) {
        return this._http.get(`${this._env}/vendas/tabpreco/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    delete(id) {
        return this._http.delete(`${this._env}/vendas/tabpreco/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAll(column, order, page, limit, situacao, ...params) {
        return this._http.get(encodeURI(`${this._env}/vendas/tabpreco.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findByIdProduct(id){
        return this._http.get(`${this._env}/vendas/${id}/tabpreco.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacao(tabelapreco) {
        return this._http.post(`${this._env}/vendas/tabpreco/updatesituacao`, tabelapreco, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAllComboTabPreco( limit = 100, ...params){
        return this._http.get(`${this._env}/vendas/tabpreco/findallcombo.json?limit=${limit}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllCombo(idTabPreco, idEmpresa, idTabprecopai = "0", ...param) {
        return this._http.get(encodeURI(`${this._env}/vendas/tabprecocombo.json?idTabPreco=${idTabPreco}&idEmpresa=${idEmpresa}&idTabprecopai=${idTabprecopai}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}